module.exports = __webpack_public_path__ + "static/media/1417954503.43f10854.ttf";